import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Horse } from '../../models/horse';

@Component({
  standalone: false,
  selector: 'app-modal-edit-horse-on-entry',
  templateUrl: './modal-edit-horse-on-entry.component.html',
styleUrls:  ['./modal-edit-horse-on-entry.component.css']
})
export class ModalEditHorseOnEntryComponent implements OnInit {

horse: Horse;

change$: EventEmitter<boolean> = new EventEmitter<boolean>();
save$: EventEmitter<Horse> = new EventEmitter<Horse>();


constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  handleChangeHorse(){
  	this.change$.emit(true);
  }

  onSaveHorse(horse: Horse){
  	this.save$.next(horse);
  }

}
